module.exports = "/* input.ng-invalid.ng-touched,\r\ntextarea.ng-invalid.ng-touched {\r\n  border: 1px solid red;\r\n} */\r\n\r\n.InvalidZipCls{\r\n  border: 1px solid red;\r\n}\r\n\r\n.btn-proceedtopay{\r\n  background: #277F5C;\r\n  border: solid 1px #277F5C;\r\n  color: #fff;\r\n  border-radius: 3px;\r\n  padding: 4px 25px;\r\n  font-size: 16px;\r\n  min-width: 151px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shoppingcart/address/address.component.css
// module id = ./src/app/shoppingcart/address/address.component.css
// module chunks = main